import { TemplateTypes } from '../constants/templateConstants';

const setAddFieldTool = (tool) => ({
    type: TemplateTypes.SET_ADDFIELD,
    tool
});

const setFieldProp = (key, value) => ({
    type: TemplateTypes.SET_FIELD_PROP,
    key, 
    value
});

const cleanFieldProp = () => ({
    type: TemplateTypes.CLEAN_FIELD_PROP,
});

const setSelected = (props, id) => ({
    type: TemplateTypes.SET_SELECTED,
    props, 
    id
});

const setContent = (content) => {
    return {
        type: TemplateTypes.SET_CONTENT,
        content
    };
}

const loadContent = (content) => ({
    type: TemplateTypes.LOAD_CONTENT,
    content
});

const setNumPages = (pages) => ({
    type: TemplateTypes.SET_NUMPAGES,
    pages
});

const setMinNumPages = (minPages) => ({
    type: TemplateTypes.SET_MIN_NUMPAGES,
    minPages
});

export default {
    setAddFieldTool,
    setFieldProp,
    cleanFieldProp,
    setSelected,
    setContent,
    loadContent,
    setNumPages,
    setMinNumPages
};